import React from 'react';
import Image from 'next/legacy/image';
import Research1 from '../../public/assets/graphics/research1.png';
import Research2 from '../../public/assets/graphics/brain-image.png';
import { LargeHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';
import LargeButton from '@/components/Views/Buttons';
import { PARENT_CHECKOUT_PATH, TEACHER_SIGNUP_PATH } from '@/lib/defaults';

interface Props {
    heading?: string;
    subhead?: string;
}

const Research = ({ heading, subhead }: Props) => {

    return (
        <div className='default-py default-px  w-full font-Inter pt-10 mt-0'>
            <div className='my-0 mx-auto flex flex-col-reverse gap-10 lg:flex-row items-center lg:items-start justify-start default-max-w'>
                <div className='-bg-red-100 w-full lg:w-[50%] xl:w-[50%] hidden lg:flex justify-center lg:justify-start items-center'>
                    <Image className='' width={648} height={1010} layout='intrinsic' src={Research1} alt='Research graphs' aria-hidden='true' />
                </div>
                <div className='-bg-green-100 w-full lg:w-[50%] xl:w-[50%] lg:ml-7mt-10 lg:mt-0'>
                    <div className='lg:no-min-h-[350px] lg:pt-5 mb-10 lg:mb-0'>
                        <LargeHeading heading={heading} style={{ textAlign: 'left' }} />
                        <NormalText className='text-left w-full mx-auto mt-8 ml-0'>{subhead}</NormalText>
                        <div className='mt-10'>
                            <div className='lg:hidden'>
                                <div className='flex w-full lg:max-w-[810px] justify-center lg:justify-start items-center lg:pt-20 xl:pt-0 mt-10'>
                                    <Image className='' src={Research2} alt='Music on the Brain' aria-hidden='true' />
                                </div>
                            </div>
                            <div className='button-group md:flex-col'>
                                <LargeButton
                                    className='bg-[#6B7280] hover:bg-[#4a4c50] w-[220px]'
                                    text='Read Research'
                                    href='/research'
                                    rightArrow={true}
                                />
                                <LargeButton
                                    className='purple-button w-[220px]'
                                    text='Sign Up My Child'
                                    href={PARENT_CHECKOUT_PATH}
                                />
                                <LargeButton
                                    className='blue-button w-[220px]'
                                    text='Sign Up As Educator'
                                    href={TEACHER_SIGNUP_PATH}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='hidden lg:block'>
                        <div className='w-full lg:max-w-[810px] flex justify-center lg:justify-start items-center lg:pt-20 xl:pt-0 mt-10'>
                            <Image className='' src={Research2} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Research;
